export const USERS ={
  ADMIN: 'super_admin',
  BUSINESS_ADMIN:'business_admin',
  BUSINESS_USER: 'business_manager',
}



// WEBPACK FOOTER //
// ./src/constants/Users.js